import React from 'react';
import LiveTest from "./liveTest";
import LiveTestCardLoader from "../common/loaders/LiveTestCardLoader";
import { CNavLink } from "../common/Header/c/CHeader";
import { useLiveTestDashboardData, useTranslations } from "examsbook-react-sdk/custom-hooks";

/**
 * List test dashboard widget
 */

function LiveTestDashboardSection(props) {
    const t = useTranslations();
    const { liveTestLoading, liveTestList } = useLiveTestDashboardData();

    function renderLoading() {
        //we will show three cards to fill this space.
        return (
            <div>
                <LiveTestCardLoader/>
                <LiveTestCardLoader/>
                <LiveTestCardLoader/>
            </div>
        );
    }

    function renderTests(liveTestsList) {
        return (
            liveTestsList && liveTestsList.length ? liveTestsList.map((data, liveKeyIndex) => {
                if (!data.attempted) {
                    return (
                        <div key={liveKeyIndex} className="suggested-test">
                            <LiveTest testData={data}/>
                        </div>
                    );
                }
            }) : 'No live test for this exam.'
        );
    }

    let trimmedTestList = liveTestList;
    if (liveTestList && liveTestList.length > 8) {
        trimmedTestList = liveTestList.slice(0, 8);
    }
    return (
        <div>
            {
                (liveTestLoading || trimmedTestList.length) > 0 && <div className="exam-board mock-test-strip">
                    <div className="exam-heading">
                        <h2>{t('Suggested_tests')}</h2>
                        <CNavLink to="/my-app/tests">{t('view_all')}</CNavLink>
                    </div>
                    <div className="flexBox-container webBox-container">
                        {
                            !liveTestLoading ? renderTests(trimmedTestList) : renderLoading()
                        }
                    </div>
                </div>
            }
        </div>
    );
}

export default LiveTestDashboardSection;
